// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define our single API slice object
export const singularApiSlice = createApi({
  reducerPath: "singularApi",
  // All of our requests will have URLs starting with '/fakeApi'
  baseQuery: fetchBaseQuery({
    baseUrl: "https://app.singular.live/apiv1",
  }),
  endpoints: (builder) => ({
    getLayoutStatus: builder.query<Array<any>, any>({
      query: () => "control/07R3fzGV3Xk2ggDyXOVyjr",
    }),
  }),
});

// Export the auto-generated hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetLayoutStatusQuery } = singularApiSlice;
